import React from "react"
import {
  FormControl, FormLabel, Radio, RadioGroup, Stack, Box, Text,
} from "@chakra-ui/react"
import { Control, useController } from "react-hook-form"
import { Boolean } from "utilities/enums"
import PriceField from "components/ReactHookForm/PriceField"

type Props = {
  control: Control<any>
  currency: string
}

// Vertical "Ticket Price" column for the redesigned form modal: a label on top,
// then the Regular Pricing radio + amount, and the Variable / Donation radio.
const TicketPrice = ({ control, currency }: Props) => {
  const { field: priceField } = useController({ name: "price", control })
  const { field: variablePriceField } = useController({ name: "variablePrice", control })

  const selectedValue = variablePriceField.value === true ? Boolean.False : Boolean.True
  const isRegularPriceSelected = selectedValue === Boolean.True
  const isLessOrEqualZero = priceField?.value <= 0

  return (
    <FormControl mb={4}>
      <FormLabel fontWeight="semibold" mb={3}>Ticket Price</FormLabel>
      <RadioGroup
        value={selectedValue}
        onChange={(value) => variablePriceField.onChange(value !== Boolean.True)}
      >
        <Stack spacing={3} align="flex-start">
          <Radio value={Boolean.True} alignItems="center">
            <Box ml={1} mt="0px" lineHeight={2}>Regular Pricing</Box>
          </Radio>
          <Box mt={1}>
            <PriceField
              name="price"
              control={control}
              w={32}
              disabled={!isRegularPriceSelected}
              rightText={currency}
              precision={2}
            />
          </Box>
          <Radio value={Boolean.False} alignItems="center">
            <Box ml={1} mt="0px" lineHeight={2}>Variable / Donation</Box>
          </Radio>
        </Stack>
      </RadioGroup>
      {isRegularPriceSelected && isLessOrEqualZero && (
        <Text color="red.400" mt={2}>You must provide a price</Text>
      )}
    </FormControl>
  )
}

export default TicketPrice
